import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";

const COACH_IMG = "https://customer-assets.emergentagent.com/job_0772848b-513c-4c6a-bb87-fb9de12093be/artifacts/602eb93p_Screenshot%202026-05-18%20at%2011.34.30%E2%80%AFAM.png";

const philosophy = [
  { t: "Smart Progression", b: "Build the engine before the speed. Mileage you can absorb beats mileage you can survive." },
  { t: "Recovery-First Performance", b: "Hard sessions only work when fully recovered. Sleep, mobility, parasympathetic recovery." },
  { t: "Injury Prevention", b: "Strength, asymmetry checks, gradual load — keep you on the road for years, not weeks." },
  { t: "Nervous System Balance", b: "Breathwork, cold exposure, sauna and quiet days. Performance lives in regulation." },
];

const credits = [
  ["7:49", "3000M PB"],
  ["13:27", "5000M PB"],
  ["61:43", "HALF MARATHON PB"],
  ["2:15:18", "MARATHON PB"],
];

export default function About() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="about-page">
      <PublicNav />
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-[#1f1f1f]">
        <div className="grid md:grid-cols-2">
          <div className="relative h-[60vh] md:h-[80vh] order-2 md:order-1">
            <img src={COACH_IMG} alt="Jean-Pierre Lautredoux" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#070707] via-transparent to-transparent md:hidden" />
            <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-[#070707] to-transparent" />
          </div>
          <div className="px-6 sm:px-10 py-12 md:py-24 order-1 md:order-2 flex flex-col justify-center">
            <div className="font-mono-jp text-xs text-[#d7ff00] tracking-[0.3em] uppercase mb-3">ABOUT THE COACH</div>
            <h1 className="font-display text-5xl sm:text-7xl uppercase leading-[0.9]">Jean-Pierre<br /><span className="text-[#d7ff00]">Lautredoux</span></h1>
            <p className="mt-6 text-[#bbb] max-w-md">French born, Kuala Lumpur based. Former French National Team runner. Former Malaysia National Coach. World Athletics certified. Nutritionist and osteotherapist.</p>
            <p className="mt-4 text-[#bbb] max-w-md">Three decades of coaching — from absolute beginners to athletes ranked at the World Championships. The same principles work at every level: consistency, recovery, intelligent progression.</p>
          </div>
        </div>
      </section>

      {/* PBs */}
      <section className="border-b border-[#1f1f1f]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-12">
          <div className="font-mono-jp text-xs tracking-[0.3em] uppercase text-[#888] mb-6">CAREER HIGHLIGHTS</div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1f1f1f]">
            {credits.map(([v, l]) => (
              <div key={l} className="bg-[#0a0a0a] p-6">
                <div className="font-mono-jp text-3xl sm:text-4xl text-[#d7ff00] tick">{v}</div>
                <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888] mt-1">{l}</div>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-2 font-mono-jp text-[10px] uppercase tracking-widest">
            {["TOP 20 WORLD CHAMPIONSHIPS","WORLD ATHLETICS COACH","NUTRITIONIST","OSTEOTHERAPIST","NATIONAL COACH"].map(c => (
              <span key={c} className="border border-[#222] px-3 py-1 text-[#bbb]">{c}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="border-b border-[#1f1f1f]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-16">
          <h2 className="font-display text-4xl sm:text-6xl uppercase">Coaching <span className="text-[#d7ff00]">Philosophy</span></h2>
          <div className="mt-10 grid sm:grid-cols-2 gap-px bg-[#1f1f1f]">
            {philosophy.map(p => (
              <div key={p.t} className="bg-[#0a0a0a] p-6">
                <div className="font-display text-2xl uppercase mb-2">{p.t}</div>
                <p className="text-[#bbb] text-sm leading-relaxed">{p.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 sm:px-10 py-16 text-center">
        <h3 className="font-display text-3xl sm:text-5xl uppercase">Ready to <span className="text-[#d7ff00]">train smart?</span></h3>
        <button onClick={() => nav("/features")} className="mt-8 bg-[#d7ff00] text-black font-display tracking-wider uppercase text-xl px-10 py-4 hover:bg-white active:scale-[0.98]" data-testid="choose-goal-cta">See What's Inside</button>
      </section>
    </div>
  );
}
